import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { changeShowModal } from "../../../store/actions/SideMenu";
import { Button } from '../../FormComponents/Button/Button';
import s from '../style/modalStyle.module.scss';

export const ModalUpdateSite = (props: any) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const backToSitesPage = () => {
        history.push(`/sites`);
        dispatch(changeShowModal({ 'nameModal': "updateSite", 'stateModal': false, otherParams: undefined }))
    }
    
    return (
        <div className={s.modalBox}>
            <div className={s.title}> Done!</div>
            <div className={s.description}>New Site was successfully published</div>
            <Button text="Back to Sites list" type="submit" class_type="secondary" onClick={() => backToSitesPage()} />
        </div>
    )
}